import { BaseLoader } from "../code/asset_loading/BaseLoader";
import { LoadManager } from "../code/asset_loading/LoadManager";
import { PIXI } from "./tbPIXI";
import { tbLoaderManager } from "./tbLoaderManager";
import { tbLoader } from "./tbLoader";
var tbTexture = /** @class */ (function () {
    function tbTexture(name, number, loadMoment) {
        this.number = 1;
        this.didLoad = false;
        this.bitmaps = [];
        this.textures = [];
        this.filenames = [];
        this.name = name;
        this.loadMoment = loadMoment;
        tbLoader.addResource(this, this.loadMoment, this.number);
        this.cache = PIXI["utils"]["TextureCache"];
        this.loader = new PIXI["loaders"]["Loader"]();
    }
    tbTexture.prototype._bitmapLoaded = function (moment) {
        tbLoader.loadComplete(moment);
    };
    tbTexture.prototype._bitmapFailed = function (moment) {
        tbLoader.loadFailed(moment);
    };
    tbTexture.prototype.startLoading = function (moment, location) {
        var _this = this;
        console.log("tbTexture startLoading", moment);
        if (tbLoader.complete(moment) && this.didLoad) {
            return Promise.resolve();
        }
        if (this._loadPromise) {
            return this._loadPromise;
        }
        // this.loader is used by the framework version of this call that is being overwritten here
        // These checks are here to make sure the files haven't already been loaded, as that would double count them which causes the game to get stuck
        if (this.loader.loading) {
            this._loadPromise = new Promise(function (resolve, reject) {
                _this.loader.onComplete.add(resolve);
                _this.loader.onError.add(reject);
            });
            return this._loadPromise;
        }
        else if (this.loader.progress === 100) {
            this._loadPromise = Promise.resolve();
            return this._loadPromise;
        }
        if (this.baseLoader === undefined) {
            this.baseLoader = new BaseLoader();
        }
        if (this.filenames === undefined || this.filenames.length === 0) {
            Promise.reject("tbTexture has no filenames " + this.name);
        }
        this._loadPromise = new Promise(function (resolve, reject) {
            var retryAttempts = 1;
            var onError = function (error) { return reject(error); };
            var onLoadDone = function (resources) {
                var failed = [];
                var succeded = [];
                for (var i = 0; i < _this.filenames.length; i++) {
                    var resource = resources[_this.filenames[i]];
                    var imageResource = resources[_this.filenames[i] + "_image"];
                    if (resource === undefined || imageResource === undefined) {
                        console.error("Failed to find texture " + _this.filenames[i] + " in loaded data");
                        failed.push(_this.filenames[i]);
                    }
                    else if (resource.error != null || imageResource.error != null) {
                        var error = resource.error ? resource.error : imageResource.error;
                        console.error("Texture Loading Error:", error, _this.filenames[i]);
                        failed.push(_this.filenames[i]);
                    }
                    // Making sure the texture has all the correct data to be sure it loaded correctly
                    else if (resource.textures === undefined || imageResource.texture === undefined ||
                        imageResource.texture.baseTexture === undefined || !imageResource.texture.baseTexture.hasLoaded ||
                        (imageResource.texture.baseTexture.width <= 1 && imageResource.texture.baseTexture.height <= 1)) {
                        console.error("Texture(s) did not load correctly", resource, imageResource);
                        failed.push(_this.filenames[i]);
                    }
                    else {
                        LoadManager.logLoadInfo("Loaded texture", _this.filenames[i], moment);
                        succeded.push(_this.filenames[i]);
                    }
                }
                if (succeded.length === _this.filenames.length) {
                    LoadManager.logLoadInfo("Textures Load SUCCESS", _this.filenames);
                    _this.didLoad = true;
                    tbLoader.loadComplete(_this.loadMoment);
                    tbLoaderManager.createSprites(_this);
                    resolve();
                }
                else {
                    LoadManager.logLoadInfo("Textures Load FAILED (" + retryAttempts + ")", failed);
                    if (retryAttempts < LoadManager.loadRetryMax) {
                        // Reload failed assets
                        retryAttempts++;
                        _this.baseLoader.reset();
                        setTimeout(_this.baseLoader.loadAsset.bind(_this.baseLoader), LoadManager.loadRetryDelay, onLoadDone, onError);
                    }
                    else {
                        reject("Failed to load texture(s) after " + retryAttempts + " tries: " + failed.toString());
                    }
                }
            };
            _this.baseLoader.prepareAsset(_this.filenames);
            _this.baseLoader.loadAsset(onLoadDone, onError);
        });
        return this._loadPromise;
    };
    tbTexture.prototype.complete = function () {
        for (var i = 0; i < this.bitmaps.length; i += 1) {
            if (!this.bitmaps[i].complete || this.bitmaps[i].width === 0) {
                return false;
            }
        }
        return true;
    };
    tbTexture.prototype.addBitmap = function (number, filename) {
        this.filenames.push(filename);
    };
    tbTexture.prototype.addImage = function (number, image) {
        if (number >= 0 && number < this.number) {
            this.bitmaps[number] = image;
            this.filenames[number] = "";
        }
    };
    tbTexture.prototype.getAtlasImages = function (filename) {
        if (this.baseLoader === undefined) {
            return undefined;
        }
        var resource = this.baseLoader.getResource(filename);
        if (resource === undefined) {
            return undefined;
        }
        return resource.textures;
    };
    return tbTexture;
}());
export { tbTexture };
